import { render } from "./SuccessCart.vue?vue&type=template&id=2eac8632"
import script from "./SuccessCart.vue?vue&type=script&lang=js"
export * from "./SuccessCart.vue?vue&type=script&lang=js"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__